/**
 * @generated SignedSource<<1cd24925e8bf0048625fe8c4eaca9593>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DatasetVersionTableRecordsFragmentPaginationQuery$variables = {
  id: string;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
};
export type DatasetVersionTableRecordsFragmentPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"DatasetVersionTableRecordsFragment">;
  };
};
export type DatasetVersionTableRecordsFragmentPaginationQuery = {
  response: DatasetVersionTableRecordsFragmentPaginationQuery$data;
  variables: DatasetVersionTableRecordsFragmentPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "limit"
},
v2 = {
  "defaultValue": 0,
  "kind": "LocalArgument",
  "name": "offset"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DatasetVersionTableRecordsFragmentPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": (v4/*:: as any*/),
            "kind": "FragmentSpread",
            "name": "DatasetVersionTableRecordsFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "DatasetVersionTableRecordsFragmentPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v4/*:: as any*/),
                "kind": "ScalarField",
                "name": "records",
                "storageKey": null
              }
            ],
            "type": "DatasetVersion",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "70be0a251c77ffdeeaa00afa76780703",
    "id": null,
    "metadata": {},
    "name": "DatasetVersionTableRecordsFragmentPaginationQuery",
    "operationKind": "query",
    "text": "query DatasetVersionTableRecordsFragmentPaginationQuery(\n  $limit: Int = 10\n  $offset: Int = 0\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...DatasetVersionTableRecordsFragment_21LIQA\n    id\n  }\n}\n\nfragment DatasetVersionTableRecordsFragment_21LIQA on DatasetVersion {\n  id\n  records(limit: $limit, offset: $offset)\n}\n"
  }
};
})();

(node as any).hash = "d48a32a8e7c793fd2171b692a61f6607";

export default node;
